import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Message } from 'primeng/api';
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { BBResponseContainer } from "../common-services/response-container";
import { Ticket } from "./ticket";

@Injectable()
export class TicketService {

    defaultTimeout: 600000;
    url: string;
    msgs: Message[] = [];

    constructor(private http: HttpClient) {
    }

    createTicket(ticket: Ticket): Observable<BBResponseContainer>  {
        console.log(ticket)
        this.url = environment.BB_TICKET_SERVICE_URL + "ticket";
        return this.http.post<BBResponseContainer>(this.url, ticket);
    }
}